import React, { useState, useEffect, memo } from 'react'
import GMap from '..'
import { TYPES } from './const'
import { getInfoWindowContent } from './util'

const DisplayMap = memo(({ onMapLoad, markers, polygons, paths, center }) => {
  const [google, setScript] = useState(null)
  const [map, setMap] = useState(null)
  const [figures, setFigures] = useState([])

  useEffect(() => {
    if (!google || !map) return
    onMapLoad(google, { map, markers, paths, polygons })
  }, [map, google])

  useEffect(() => {
    if (!google || !map) return
    renderItems()
  }, [map, google, markers, paths, polygons])

  useEffect(() => {
    if (map) {
      map.setCenter(center)
    }
  }, [center])

  const renderItems = () => {
    eraseOldFigures()

    renderPaths(paths)
    renderMarkers(markers)
    renderPolygons(polygons)
  }

  const renderPaths = paths => paths && paths.forEach(renderPath)
  const renderMarkers = markers => markers && markers.forEach(renderMarker)
  const renderPolygons = polygons => polygons && polygons.forEach(renderPolygon)

  const renderPath = polyline =>
    polyline &&
    saveFigure({
      newFigure: new google.maps.Polyline({
        map: map,
        path: polyline.path,
        geodesic: true,
        strokeOpacity: 1.0,
        strokeWeight: 2,
        ...polyline.options,
      }),
      rawObj: polyline,
      type: TYPES.POLYLINE,
    })

  const renderMarker = marker =>
    marker &&
    saveFigure({
      newFigure: new google.maps.Marker({
        position: marker.position,
        map: map,
        icon: {
          path: google.maps.SymbolPath.CIRCLE,
        },
        ...marker.options,
      }),
      rawObj: marker,
      type: TYPES.MARKER,
    })

  const renderPolygon = polygon =>
    polygon &&
    saveFigure({
      newFigure: new google.maps.Polygon({
        map: map,
        paths: polygon.path,
        clickable: false,
        ...polygon.options,
      }),
      rawObj: polygon,
      type: TYPES.POLYGON,
    })

  const saveFigure = ({ newFigure, rawObj, type }) => {
    const { infoWindowSettings } = rawObj.options

    newFigure.addListener('click', ({ latLng }) => {
      const infoWindow = new google.maps.InfoWindow({
        ...infoWindowSettings,
        position: latLng,
        content: getInfoWindowContent({
          type,
          clickCoords: latLng.toJSON(),
          path: rawObj.path,
          fallbackContent: infoWindowSettings.content,
        }),
      })

      infoWindow.open(map)
    })
    setFigures(existingFigures => [...existingFigures, newFigure])
  }

  const onInit = (map, google) => {
    setMap(map)
    setScript(google)
  }

  const eraseOldFigures = () => figures.forEach(figure => figure.setMap(null))

  return (
    <GMap
      onInit={onInit}
      mapSettings={{
        zoom: 12,
        center,
      }}
    />
  )
})

export default DisplayMap



// WEBPACK FOOTER //
// ./src/Components/GMap/DisplayMap/index.jsx